import { forwardPropsToState } from 'utils/react_utils';
import RealizeLabel  from 'realize/components/label/label';
import { FormAPI } from 'lecom-api';
import { FormEvents } from '../../../form/events/form_event_handler';

const RealizeInputRadioGroup = window.InputRadioGroup;

@forwardPropsToState([
	{ prop: 'value', defaultValue: null },
	{ prop: 'options', defaultValue: [] },
	{ state: 'optionsCache', prop: 'options', defaultValue: [] },
])
export default class InputRadioGroup extends RealizeInputRadioGroup {
	constructor(props) {
		super(props);
		this.selectedOptions = InputRadioGroup.prototype.selectedOptions.bind(this);
		this.renderOptions = InputRadioGroup.prototype.renderOptions.bind(this);
		this.handleLoad = InputRadioGroup.prototype.handleLoad.bind(this);
	}

	getProp(key, obj) {
		var keyArr = key.split('.');
		var prop = obj;

		try {
			while(keyArr.length > 0) {
				prop = prop[keyArr.shift()];
			}
		}
		catch(err) {
			return '';
		}

		return prop;
	}

	handleLoad(data) {
		var options = [];
		var optionsParam = this.props.optionsParam;

		if(!!optionsParam) {

			data = this.getProp(optionsParam, data);
		}

		for(var i = 0; i < data.length; i++) {
			var dataItem = data[i];

			var option = {
				name: String(dataItem[this.props.nameField]),
				value: dataItem[this.props.valueField]
			};

			options.push(option);
		}

		this.setState({
			loadData: data,
			options: options,
			optionsCache: this.cacheOptions(options),
			mustDisable: (!!this.props.dependsOn && options.length <= 0)
		}, this.triggerDependableChanged);

		this.state.hasPendingRequest = false;
		this.props.onLoad(data);

		const id = this.getPropsId();

		if (this.props.gridFormParent) {
			if (Form.grids(this.props.gridFormParent) && Form.grids(this.props.gridFormParent).fields(id)) {
				Form.grids(this.props.gridFormParent).fields(id).publish(FormEvents.LOAD_OPTIONS_SUCCESS, options);
			}
		}
		else {
			if (Form.fields(id)) {
				Form.fields(id).publish(FormEvents.LOAD_OPTIONS_SUCCESS, options);
			}
		}
	}

	selectedOptions() {
		const value = this.ensureIsArray(this.state.value);
		return this.state.optionsCache.filter(option => value.includes(option.value));
	}

	componentDidMount() {
		if (this.props.optionsUrl) {
			if (!!this.props.dependsOn) {
				this.listenToDependableChange();
				this.loadDependentOptions(null, true);
			} else {
				this.loadOptions();
			}
		}

		if (this.state.value.length > 0) {
			this.triggerDependableChanged();
		}

		setTimeout(() => { this.tabOrderRadio() }, 1000);
	}

	componentDidUpdate(){
		setTimeout(() => { this.tabOrderRadio() }, 1000);
	}

	handleKeyDown(e) {
        if(e.keyCode === 32){
            e.preventDefault();
			e.stopPropagation();
			e.currentTarget.click();
        }
    }

	tabOrderRadio(){
		const formAPI = FormAPI.form(this.props.formId);
		let idField = this.props.gridFormParent === null ? this.props.id : null;
		let idFieldGrid = this.props.gridFormParent ? this.props.id : null;

		if(idField){
			let propsDisabled = this.props.disabled;
			let radioButton = $(`#input__${idField} .tab-radio-button`);
			let fieldReadOnly = formAPI.fields(idField).readOnly();

			if(propsDisabled !== true){
				radioButton.attr('tabindex', '0');

				if(fieldReadOnly !== true){
					radioButton.attr('tabindex', '0');
				} else { radioButton.off('keypress') }
			} else {
				radioButton.off('keypress');
				radioButton.attr('tabindex', '-1');
			}
		}
		else if(idFieldGrid){
			let idGrid = this.props.gridFormParent;
			let propsDisabled = this.props.disabled;
			let radioButton = $(`#input__${idFieldGrid} .tab-radio-button`);
			let readOnly = formAPI.grids(idGrid).fields(idFieldGrid);

			if(propsDisabled !== true){
				radioButton.attr('tabindex', '0');

				if(readOnly !== true){
				} else { radioButton.off('keypress'); }
			} else {
				radioButton.off('keypress');
				radioButton.attr('tabindex', '-1');
			}
		}

		else {
			let radioButton = $(`#input__${idFieldGrid} .tab-radio-button`);
			radioButton.removeAttr('tabindex');
		}
	}

	buildOptionProps(optionProps, index) {
		const { name, withGap, disabled, readOnly, defaultValue, gridFormParent } = this.props;

		let { currentValue, value } = this.state;

		const hasValue = value && value.length > 0;
		const isValueArray = Array.isArray(value);

		if (hasValue && isValueArray) {
			value = value[0];
		}

		if (!hasValue && defaultValue?.trim() && gridFormParent) {
			const { formId, id, defaultValue } = this.props;

			const formApi = FormAPI.form(formId);
			formApi.grids(gridFormParent).fields(id).value(defaultValue).apply();
		}

		return {
			...optionProps,
			disabled: disabled || (readOnly && !optionProps.checked),
			id: `${name}_${index}`,
			type: 'radio',
			defaultChecked: optionProps.value && currentValue === optionProps.value,
			checked: optionProps.value && value === optionProps.value,
			className: !!withGap ? 'with-gap' : '',
		}
	}

	handleBlur(event){
		setTimeout(() => {
			if (!$(document.activeElement).closest(`#${this.getPropsId()}`).length) {
				window['focusRadio'] = "";

				if (this.props.onBlur) {
					this.props.onBlur(event, this.state.value, this);
				}
			}
		}, 0);
	}

	handleFocus(event){
		setTimeout(() => {
			if (!window['focusRadio']) {
				window['focusRadio'] = this.getPropsId();

				if (this.props.onFocus) {
					this.props.onFocus(event, this.state.value, this);
				}
			}
		}, 0);
	}

	handleChange(event) {
		if (window.importMultipleGridOpen) {
			const formAPI = FormAPI.form(this.props.formId);
			const fieldAPI = formAPI.grids(window.importMultipleGridId).fields(this.props.id);

			setTimeout(() => {
				fieldAPI.apply();
			}, 0);

			setTimeout(() => {
				const contentFieldsGrid = 'div.content-fields-grid.is-open';
				const inputRadio = `div#input__${this.props.id} input`;
				const value = this.props.value;

				$(contentFieldsGrid).find(inputRadio).each(function() {
					if ($(this)[0].defaultValue === value) {
						$($(this)[0]).prop('checked', true);
						return;
					}

					$($(this)[0]).prop('checked', false);
				});
			}, 100);
		}

		this._handleChange(event);
	}

	renderOption(optionProps, index) {
		const builtOptionProps = this.buildOptionProps(optionProps, index);

		return (
			<p key={`p_input_${index}`} id={`input_${optionProps.value}`}>
				<input
					{...this.props}
					{...builtOptionProps}
					name={this.props.name}
					onChange={this.handleChange.bind(this)}
					onBlur={e => {}}
					onFocus={e => {}}
					aria-checked={!builtOptionProps.checked ? false : true}
					aria-disabled={builtOptionProps.disabled}
					role="radio"
				/>
				<RealizeLabel
					id={builtOptionProps.id}
					label={builtOptionProps.name}
					onKeyDown={this.handleKeyDown.bind(this)}
					className="tab-radio-button"
					checked={(typeof builtOptionProps.checked === "string") ? true : false}
					disabled={builtOptionProps.disabled} role="radio"
				/>
			</p>
		);
	}

	renderOptions() {
		return this.state.options.map(this.renderOption.bind(this));
	}

	getPropsId(){
		return this.props.id ? this.props.id : this.props.label ? this.props.label.replace(/ /g,"_") : 'id_radiogroup';
	}

	render() {
		return (
			<fieldset aria-label={this.props.label} style={{border: 'none'}} id={this.getPropsId()} role="radioGroup" onFocus={this.handleFocus.bind(this)} onBlur={this.handleBlur.bind(this)}>
				<div className={'input-checkbox-group align-' + this.props.align} ref="radioGroup" role="radio">
				{this.renderOptions()}
				</div>
			</fieldset>
		);
	}
}
